import React from 'react'

import { Field, Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Button, Card, Col, Form, Row } from '_zari/core'

import { MesesContabilidadConstant, TiposBloqueoPeriodoConstant } from 'constants/index'

import { IdGen } from 'utils'

import * as BloqueosPeriodoService from 'services/bloqueosPeriodo.service'

const init0to15 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
const init0to14 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]

const MainForm = ({ bloqueosInfo }) => {
  const __zariContext = React.useContext(ZariContext)

  // const mayorizados = bloqueosInfo.mayorizados || [...init0to14]
  const [__keyContainer, setKeyContainer] = React.useState(IdGen.newId())
  const [mayorizados] = React.useState(bloqueosInfo.mayorizados || [...init0to14])
  // const [mayorizados, setMayorizados] = React.useState(bloqueosInfo.mayorizados || [...init0to14])
  const [bloqueosVentas, setBloqueosVentas] = React.useState(bloqueosInfo.bloqueosVentas || [...init0to15])
  const [bloqueosCompras, setBloqueosCompras] = React.useState(bloqueosInfo.bloqueosCompras || [...init0to15])
  const [bloqueosGlobales, setBloqueosGlobales] = React.useState(bloqueosInfo.bloqueosGlobales || [...init0to15])
  const [bloqueosPase, setBloqueosPase] = React.useState(bloqueosInfo.bloqueosPase || [...init0to15])

  const formInitialValues = React.useMemo(() => {
    return {
      tipo: bloqueosInfo.tipo || TiposBloqueoPeriodoConstant.COMPRAS_VENTAS
    }
  }, [bloqueosInfo])

  const onChangeCheckboxLista = React.useCallback((idLista, value) => {
    if (idLista === 'listaCompras') {
      setBloqueosCompras(prev => {
        if (prev[value] === 1) {
          prev[value] = 0
        } else {
          prev[value] = 1
        }

        return prev
      })
    } else if (idLista === 'listaVentas') {
      setBloqueosVentas(prev => {
        if (prev[value] === 1) {
          prev[value] = 0
        } else {
          prev[value] = 1
        }
        return prev
      })
    } else if (idLista === 'listaPase') {
      setBloqueosPase(prev => {
        if (prev[value] === 1) {
          prev[value] = 0
        } else {
          prev[value] = 1
        }
        return prev
      })
    } else {
      setBloqueosGlobales(prev => {
        if (prev[value] === 1) {
          prev[value] = 0
        } else {
          prev[value] = 1
        }
        return prev
      })
    }

    setKeyContainer(IdGen.newId())
  }, [])

  const listaBloqueos = React.useCallback(
    (idLista, inicio, fin = 12) => {
      let salida = []

      for (let i = inicio; i <= fin; i++) {
        const idCodigo = `${i}`.padStart(2, '0')
        const mesCodigo = MesesContabilidadConstant.__dictionary[idCodigo].nombre

        let checked = false
        if (idLista === 'listaCompras') {
          checked = bloqueosCompras[i] === 1
        } else if (idLista === 'listaVentas') {
          checked = bloqueosVentas[i] === 1
        } else if (idLista === 'listaPase') {
          checked = bloqueosPase[i] === 1
        } else {
          checked = bloqueosGlobales[i] === 1
        }

        salida.push(
          <Form.Checkbox
            key={`${idLista}-${i}`}
            id={`${idLista}-${i}`}
            name={idLista}
            label={`${idCodigo} ${mesCodigo}`}
            value={idCodigo}
            onChange={() => onChangeCheckboxLista(idLista, i)}
            checked={checked}
          />
        )
      }

      return salida
    },
    [bloqueosVentas, bloqueosCompras, bloqueosGlobales, onChangeCheckboxLista, bloqueosPase]
  )

  const onSubmit = React.useCallback(
    (data, { setSubmitting }) => {
      BloqueosPeriodoService.actualizarBloqueos({
        ...data,
        mayorizados,
        bloqueosVentas,
        bloqueosCompras,
        bloqueosGlobales,
        bloqueosPase
      })
        .then(() => {
          __zariContext.snack('success', 'El bloqueo se ha actualizado.')
        })
        .catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
          setSubmitting(false)
        })
    },
    [bloqueosVentas, bloqueosCompras, bloqueosGlobales, __zariContext, bloqueosPase, mayorizados]
  )

  return (
    <Formik initialValues={formInitialValues} onSubmit={onSubmit}>
      {({ values, handleSubmit }) => (
        <Form>
          <Row>
            <Col md={2}>
              <Field name='tipo'>
                {({ field }) => (
                  <Form.Radio
                    {...field}
                    id='radio-ventascompras'
                    label='Ventas-Compras'
                    value={TiposBloqueoPeriodoConstant.COMPRAS_VENTAS}
                    checked={values.tipo === TiposBloqueoPeriodoConstant.COMPRAS_VENTAS}
                  />
                )}
              </Field>
              <Field name='tipo'>
                {({ field }) => (
                  <Form.Radio
                    {...field}
                    id='radio-global'
                    label='Global'
                    value={TiposBloqueoPeriodoConstant.GLOBAL}
                    checked={values.tipo === TiposBloqueoPeriodoConstant.GLOBAL}
                  />
                )}
              </Field>
            </Col>
            <Col md={10} style={{ borderLeft: '1px solid black' }} key={__keyContainer}>
              {values.tipo === TiposBloqueoPeriodoConstant.COMPRAS_VENTAS && (
                <>
                  <Row>
                    <Col md={4}>
                      <Card>
                        <Card.Header>Bloqueo de Compras</Card.Header>
                        <Card.Body>{listaBloqueos('listaCompras', 1)}</Card.Body>
                      </Card>
                    </Col>
                    <Col md={4}>
                      <Card>
                        <Card.Header>Bloqueo de Ventas</Card.Header>
                        <Card.Body>{listaBloqueos('listaVentas', 1)}</Card.Body>
                      </Card>
                    </Col>
                    <Col md={4}>
                      <Card>
                        <Card.Header>Bloqueo de Pase</Card.Header>
                        <Card.Body>{listaBloqueos('listaPase', 1)}</Card.Body>
                      </Card>
                    </Col>
                  </Row>
                  <Row className='mt-2'>
                    <Col md={8} className='text-right'>
                      <Button onClick={handleSubmit}>Guardar</Button>
                    </Col>
                  </Row>
                </>
              )}
              {values.tipo === TiposBloqueoPeriodoConstant.GLOBAL && (
                <>
                  <Row>
                    <Col md={4}>
                      <Card>
                        <Card.Header>Bloqueos Globales</Card.Header>
                        <Card.Body>{listaBloqueos('listaGlobales', 0, 15)}</Card.Body>
                      </Card>
                    </Col>
                  </Row>
                  <Row className='mt-2'>
                    <Col md={4} className='text-right'>
                      <Button onClick={handleSubmit}>Guardar</Button>
                    </Col>
                  </Row>
                </>
              )}
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  )
}

export default React.memo(MainForm)
